import { render, staticRenderFns } from "./ModattaSettingsOther.vue?vue&type=template&id=d49a0dc4"
import script from "./ModattaSettingsOther.vue?vue&type=script&lang=js"
export * from "./ModattaSettingsOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports